import React from 'react';
/**
 * DefaultBlock is an instance of WordPressBlock that is used in case no matching component is found when rendering the list of blocks.
 * @param param0
 * @returns JSX.Element
 */
export default function DefaultBlock({ renderedHtml }) {
    // eslint-disable-next-line react/no-danger
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: renderedHtml !== null && renderedHtml !== void 0 ? renderedHtml : '' } });
}
DefaultBlock.displayName = 'DefaultBlock';
